// import React, { Component } from 'react';
// import classNames from 'classnames';

// const ORDER_TYPES = {
//     DINE_IN: 'dinein',
//     TAKEAWAY: 'takeaway',
//     DELIVERY: 'delivery',
//     QUICK_ORDER: 'quickorder'
// };

// class POSSidebar extends Component {

//     render() {
//         const { collapsed, activeOrderType, onSelectOrderType } = this.props;

//         return (
//             <div className={classNames('pos-sidebar', { 'pos-sidebar-collapsed': collapsed })}>

//                 <div
//                     className={classNames('pos-sidebar-link', {
//                         active: activeOrderType === ORDER_TYPES.DINE_IN
//                     })}
//                     onClick={() => onSelectOrderType(ORDER_TYPES.DINE_IN)}
//                 >
//                     <span className="pos-link-text">Dine In</span>
//                 </div>

//                 <div
//                     className={classNames('pos-sidebar-link', {
//                         active: activeOrderType === ORDER_TYPES.TAKEAWAY
//                     })}
//                     onClick={() => onSelectOrderType(ORDER_TYPES.TAKEAWAY)}
//                 >
//                     <span className="pos-link-text">Takeaway</span>
//                 </div>

//                 <div
//                     className={classNames('pos-sidebar-link', {
//                         active: activeOrderType === ORDER_TYPES.DELIVERY
//                     })}
//                     onClick={() => onSelectOrderType(ORDER_TYPES.DELIVERY)}
//                 >
//                     <span className="pos-link-text">Delivery</span>
//                 </div>

//                 <div
//                     className={classNames('pos-sidebar-link', {
//                         active: activeOrderType === ORDER_TYPES.QUICK_ORDER
//                     })}
//                     onClick={() => onSelectOrderType(ORDER_TYPES.QUICK_ORDER)}
//                 >
//                     <span className="pos-link-text">Quick Order</span>
//                 </div>

//             </div>
//         );
//     }
// }

// export { ORDER_TYPES };
// export default POSSidebar;
import React, { Component } from 'react';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';

export const ORDER_TYPES = {
    DINE_IN: '550e8400-e29b-41d4-a716-446655440001',
    TAKEAWAY: '550e8400-e29b-41d4-a716-446655440002',
    DELIVERY: '550e8400-e29b-41d4-a716-446655440003',
    QUICK_ORDER: '550e8400-e29b-41d4-a716-446655440004'
};

// ── Single link ───────────────────────────────────────────────────────────
// Renders a NavLink when `to` is given (real route — active state is handled
// by the router itself, same pattern as AppMenu's `to` items in App.js).
// Renders a plain clickable div when `onClick`/`active` are given instead
// (used for the Orders tabs, which switch a tab on the same page rather
// than navigating to a different route).
function SidebarLink({ icon, label, active, onClick, collapsed, to }) {
    const content = (
        <>
            <span className="pos-link-icon"><i className={`pi ${icon}`} /></span>
            <span className="pos-link-text">{label}</span>
        </>
    );

    if (to) {
        return (
            <NavLink
                to={to}
                exact
                className="pos-sidebar-link"
                activeClassName="active"
                title={collapsed ? label : undefined}
            >
                {content}
            </NavLink>
        );
    }

    return (
        <div
            className={classNames('pos-sidebar-link', { active })}
            onClick={onClick}
            title={collapsed ? label : undefined}
        >
            {content}
        </div>
    );
}

// ── Sidebar ───────────────────────────────────────────────────────────────
class POSSidebar extends Component {
    render() {
        const { collapsed, activeOrderType, onSelectOrderType } = this.props;

        return (
            <div className={classNames('pos-sidebar', { 'pos-sidebar-collapsed': collapsed })}>

                <div className="pos-sidebar-group">
                    <span className="pos-sidebar-group-label">Orders</span>

                    <SidebarLink
                        icon="pi-send"
                        label="Dine In"
                        collapsed={collapsed}
                        active={activeOrderType === ORDER_TYPES.DINE_IN}
                        onClick={() => onSelectOrderType(ORDER_TYPES.DINE_IN)}
                    />

                    <SidebarLink
                        icon="pi-shopping-bag"
                        label="Takeaway"
                        collapsed={collapsed}
                        active={activeOrderType === ORDER_TYPES.TAKEAWAY}
                        onClick={() => onSelectOrderType(ORDER_TYPES.TAKEAWAY)}
                    />

                    <SidebarLink
                        icon="pi-car"
                        label="Delivery"
                        collapsed={collapsed}
                        active={activeOrderType === ORDER_TYPES.DELIVERY}
                        onClick={() => onSelectOrderType(ORDER_TYPES.DELIVERY)}
                    />

                    <SidebarLink
                        icon="pi-bolt"
                        label="Quick Order"
                        collapsed={collapsed}
                        active={activeOrderType === ORDER_TYPES.QUICK_ORDER}
                        onClick={() => onSelectOrderType(ORDER_TYPES.QUICK_ORDER)}
                    />
                </div>

                <div className="pos-sidebar-divider" />

                <div className="pos-sidebar-group">
                    <span className="pos-sidebar-group-label">Manage</span>

                    <SidebarLink icon="pi-th-large"     label="Dashboard"     collapsed={collapsed} to="/pos/dashboard" />
                    <SidebarLink icon="pi-list"         label="Order List"    collapsed={collapsed} to="/pos/orderlist" />
                    <SidebarLink icon="pi-chart-bar"    label="Reports"       collapsed={collapsed} to="/pos/reports" />
                    <SidebarLink icon="pi-book"         label="Production Plan" collapsed={collapsed} to="/pos/productionplan" />
                    <SidebarLink icon="pi-chart-bar"    label="QR ORDER" collapsed={collapsed} to="/pos/qrorder?tableId=b1f0b8ec-df1d-425b-bd09-9aed9f2ba1bb&tableNo=T009" />
                    <SidebarLink icon="pi-money-bill"    label="Petty Cash" collapsed={collapsed} to="/pos/pettycash" />
                    <SidebarLink icon="pi-ban" label="SoldOut" collapsed={collapsed} to="/pos/soldout" />
                    <SidebarLink icon="pi-cog"          label="Online Config" collapsed={collapsed} to="/pos/onlineconfig" />
                    <SidebarLink icon="pi-calendar-times" label="Day Close"   collapsed={collapsed} to="/pos/dayclose" />
                    <SidebarLink icon="pi-calendar-times" label="Table Reservation"   collapsed={collapsed} to="/pos/tablereservationlist" />
                    <SidebarLink icon="pi pi-th-large" label="KOTDashboard" collapsed={collapsed} to="/pos/KOTDashboard" />
                    <SidebarLink icon="pi pi-inbox" label="PackingDashboard" collapsed={collapsed} to="/pos/PackingDashboard" />
                    <SidebarLink icon="pi pi-user" label="Waiter" collapsed={collapsed} to="/pos/Waiter" />
                    <SidebarLink icon="pi pi-id-card" label="Captain Dashboard" collapsed={collapsed} to="/pos/captaindashboard" />
                    <SidebarLink icon="pi pi-print" label="Print Jobs" collapsed={collapsed} to="/pos/printjobs" />
                </div>

            </div>
        );
    }
}

export default POSSidebar;